// extracted by mini-css-extract-plugin
export default {"dialogTitle":"styles__dialogTitle___GeC25","dialogContent":"styles__dialogContent___rDXzQ"};